/** Plec uzytkownika. Odpowiada enumowi `pl.tenify.common.enums.Gender`. */
export type Gender = 'MALE' | 'FEMALE';

/**
 * Profil uzytkownika zwracany przez `GET /api/users/{id}`
 * (common-lib: `UserResponse`).
 *
 * Uwaga: to DTO NIE zawiera rol globalnych — te sa dostepne wylacznie
 * w claimach tokena dostepu (`globalRoles`).
 */
export interface UserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  /** Status konta nadawany przez backend (np. `ACTIVE`). */
  status: string;
  gender: Gender;
  /** Role globalne konta (PLAYER, TRAINER, OWNER, ADMIN). */
  globalRoles?: string[];
}

/** Statusy konta, ktore moze ustawic administrator. */
export type EditableUserStatus = 'ACTIVE' | 'INACTIVE';

/** Payload rejestracji `POST /api/users` — uzywany tez przez panel ADMIN. */
export interface CreateUserRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  gender: Gender;
}

/** Payload edycji `PUT /api/users/{id}` (tylko ADMIN). */
export interface AdminUserUpdateRequest {
  firstName: string;
  lastName: string;
  /** `null` zostawia obecna plec. */
  gender: Gender | null;
  /** `null` zostawia obecny status. */
  status: EditableUserStatus | null;
}

/** Zwraca imie i nazwisko w jednym ciagu. */
export function fullNameOf(user: Pick<UserProfile, 'firstName' | 'lastName'>): string {
  return `${user.firstName} ${user.lastName}`.trim();
}
